const contentfulIds = require('./contentfulIds')

module.exports = {
  ...contentfulIds,
}
